import { render, staticRenderFns } from "./Brandings.vue?vue&type=template&id=d9cf834a&scoped=true"
import script from "./Brandings.vue?vue&type=script&lang=js"
export * from "./Brandings.vue?vue&type=script&lang=js"
import style0 from "./Brandings.vue?vue&type=style&index=0&id=d9cf834a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9cf834a",
  null
  
)

export default component.exports